
import { on } from 'delegated-events';
import helpers from './helpers.js'

/*
===================================================================
Gallery
===================================================================
*/
export default (function () {
  return {
    init() {
      if (document.querySelectorAll('.js-gallery-main').length) {
        const disableLinks = (gallery) => {
          const links = gallery.querySelectorAll('.js-gallery-launch');
          [...links].forEach((link) => {
            link.setAttribute('tabindex', '-1');
          });
        };
        const enableLinks = (gallery) => {
          const links = gallery.querySelectorAll('.js-gallery-launch');
          [...links].forEach((link) => {
            link.removeAttribute('tabindex');
          });
        };

        const closeGallery = (gallery) => {
          const detail = gallery.querySelector('.js-gallery-detail');
          const caption = gallery.querySelector('.js-gallery-caption');
          detail.classList.remove('is-open');
          caption.parentElement.classList.remove('is-shown');
          caption.innerHTML = '';
          const currentImage = parseInt(gallery.getAttribute('data-open-image'), 10);
          enableLinks(gallery);
          if (currentImage >= 0) {
            gallery.querySelectorAll('.js-gallery-launch')[currentImage].focus();
            gallery.removeAttribute('data-open-image');
          }
        };

        on('click', '.js-gallery-launch', (e) => {
          e.preventDefault();
          const targ = e.currentTarget;
          const img = targ.getAttribute('href');
          const gallery = targ.closest('.js-gallery');
          const main = gallery.querySelector('.js-gallery-main');
          const detail = gallery.querySelector('.js-gallery-detail');
          const caption = gallery.querySelector('.js-gallery-caption');

          main.style['background-image'] = `url('${img}')`;
          detail.classList.add('is-open');
          gallery.querySelector('.js-gallery-close').focus();
          gallery.setAttribute('data-open-image', helpers.indexInParent(targ));
          if (targ.getAttribute('data-caption') != null) {
            caption.parentElement.classList.add('is-shown');
            caption.innerHTML = `<p>${targ.getAttribute('data-caption')}</p>`;
          }
          disableLinks(gallery);
        });

        on('click', '.js-gallery-close', (e) => {
          e.preventDefault();
          const targ = e.currentTarget;
          const gallery = targ.closest('.js-gallery');
          closeGallery(gallery);
        });

        on('keydown', '.js-gallery', (e) => {
          if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
            closeGallery(e.currentTarget);
          }
        });
      }
    },
  };
}());
